import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../store/core/url/customizeHttpUrlGenerator';
import {ProductModel} from '../../../api/entity/product.model';
import {ProductConverter} from '../../../api/entity/converter/product.converter';

@Injectable()
export class ProductDataService extends AbstractDataServiceV2<ProductModel, ProductConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
                converter: ProductConverter) {
        super('Product', http, httpUrlGenerator, logger, config, converter);
    }
}
